<template>
  <article
      ref="root"
      class="moment"
      :class="{
      'moment--is-type-moment': isMoment,
      'reveal-animate': animateIn
    }"
      :style="{ animationDelay }"
      :key="moment.urlSegment"
      @click="onClick"
      @keydown.enter="onClick"
      @keydown.space="onClick"
      tabindex="0"
  >
  <div class="moment__inner">
    <div v-if="isMoment" class="moment__image">
      <div
          v-if="moment.imageHtml"
          class="moment__media"
          v-html="moment.imageHtml"
      ></div>
      <div v-else class="moment__no-image-container">
        <span class="moment__no-image-graphic"></span>
      </div>
    </div>
    <div v-else class="moment__image-placeholder"></div>

    <div class="moment__content-area">
      <div class="moment__text-area">
        <div class="moment__category-year-wrapper">
          <span v-if="moment.category" class="moment__category">{{ moment.category }}</span>
          <span v-else class="moment__category-placeholder"></span>
          <span class="moment__year">{{ moment.year }}</span>
        </div>

        <div class="moment__text-wrapper">
          <h4 class="moment__title">{{ moment.title }}</h4>
          <p class="moment__excerpt">{{ moment.momentExcerpt }}</p>
        </div>
      </div>

      <span class="moment__arrow"></span>
    </div>
  </div>
  </article>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import type { ITimelineMapItem } from "../../interfaces/ITimelineMapItem";

const props = defineProps<{
  moment: ITimelineMapItem;
  index?: number;
  animateIn?: boolean;
}>();

const store = useTimelineMapStore();

const root = ref<HTMLElement | null>(null);
defineExpose({ root });

const isMoment = computed(() => props.moment.type === "Moment");
const animateIn = computed(() => props.animateIn ?? false);
const animationDelay = computed(() => `${(props.index ?? 0) * 100}ms`);

function onClick() {
  if (isMoment.value) {
    store.onShowModal(props.moment);
  }
}
</script>
